import { isVinValid } from "@/lib/vin/vin-validator"

// Finding a VIN in whatever a barcode (or a person) gives us. A VIN is 17
// characters, never I, O or Q, and carries its own check digit (position 9),
// so a misread or a typo is caught instead of looking up the wrong car.
// Door-sticker barcodes on imported cars often start with an extra "I";
// insurance cards and registrations put the VIN among other fields, as its
// own field. A VIN glued inside a longer run is never trusted: about 1 in 11
// random 17-character stretches passes the check digit, so a long barcode
// (a driver's licence) would almost always "contain" one. Pure; unit-tested.

export function cleanVin(text: string): string {
  return text.toUpperCase().replace(/[^A-Z0-9]/g, "")
}

export function extractVin(raw: string): string | null {
  // Whole fields only (separated by anything that isn't a letter or digit).
  const tokens = raw.toUpperCase().split(/[^A-Z0-9]+/).filter(Boolean)
  for (const token of tokens) {
    const t = token.length === 18 && token.startsWith("I") ? token.slice(1) : token
    if (t.length === 17 && isVinValid(t)) return t
  }
  return null
}

// What someone has typed so far: VIN characters only (O → 0, I → 1, Q
// dropped are the classic misreads of a sticker), at most 17.
export function typedVin(input: string): string {
  return cleanVin(input)
    .replace(/O/g, "0")
    .replace(/I/g, "1")
    .replace(/Q/g, "")
    .slice(0, 17)
}
